import Axios from 'axios'
import qs from 'qs'
import { errors, authData as auth } from './store'


var ResposneHandler = (response) => {
  return response
}

var ErrorHandler = (error) => {
  const { response } = error

  if (!response) {
    throw error
  }
  
  if (response.status == '401' || response.status == 401) {
    localStorage.removeItem("auth")
    window.gotoLogin()
    throw errors.notLogin
  } else {
    throw error
    //Promise.reject(error)
  }
}

var configFunc = (baseURL)=> {
  return (config) => {
    return {
      ...config,
      baseURL: baseURL,
      //baseURL: 'https://erp.jibbert.com/api/v1',
      params: {
        ...config.params,
        token: auth ? auth.token : "",
        client_id: '10001'
      },
      paramsSerializer: params => qs.stringify(params)
    }
  }
}
const AxiosAPIV2 = Axios.create({
});

AxiosAPIV2.interceptors.request.use(configFunc('https://preorder.jibbert.com/api/v2'), error => Promise.reject(error))
Axios.interceptors.request.use(configFunc('https://preorder.jibbert.com/api'), error => Promise.reject(error))

Axios.interceptors.response.use(ResposneHandler, ErrorHandler)
export default AxiosAPIV2
